var UploadResumesProcessedCandidatesModalController = /** @class */ (function () {
    /*@ngInject*/
    function UploadResumesProcessedCandidatesModalController() {
    }
    UploadResumesProcessedCandidatesModalController.prototype.$onInit = function () {
        this.gettingCountsFlag = false;
        this.reviewHtmlText = "<p>Resumes processed heading</p>";
        this.candidatesCount = this.resolve.candidatesCount;
        this.jobId = this.resolve.jobId;
        this.candidateId = this.resolve.candidateId;
        this.notificationId = this.resolve.notificationId;
        this.headingTitle = this.resolve.headingTitle;
    };
    UploadResumesProcessedCandidatesModalController.prototype.closeModal = function () {
        this.modalInstance.close('cancel');
    };
    UploadResumesProcessedCandidatesModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('dismiss');
    };
    return UploadResumesProcessedCandidatesModalController;
}());
import * as TEMPLATE from 'raw-loader!./upload-resumes-processed-candidates-modal.html';
export var UploadResumesProcessedCandidatesModalComponent = {
    selector: 'uploadResumesProcessedCandidatesModal',
    component: {
        bindings: {
            modalInstance: '<',
            resolve: '<'
        },
        template: TEMPLATE.default,
        controller: UploadResumesProcessedCandidatesModalController
    }
};
//# sourceMappingURL=upload-resumes-processed-candidates-modal.component.js.map